import React from "react";

const industryBenchmarks = {
    industryName: "US Food Trucks",
    avgRevenueGrowth: "32%",
    avgProfitMargin: "18.5%",
    avgCustomerRetention: "78%",
    marketShare: "5.4%",
};

const yourMetrics = {
    avgRevenueGrowth: "28%",
    avgProfitMargin: "15.2%",
    avgCustomerRetention: "72%",
    marketShare: "3.1%",
};

const BenchmarkMetricsKPIs = () => {
    return (
        <div className="bg-white rounded-lg shadow p-6 mb-8">
            <div className="flex items-center gap-3 mb-4">
                <h3 className="text-lg font-medium text-gray-900">
                    Industry Benchmarks - {industryBenchmarks.industryName}
                </h3>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                {[
                    {
                        title: "Avg. Revenue Growth",
                        industryValue: industryBenchmarks.avgRevenueGrowth,
                        yourValue: yourMetrics.avgRevenueGrowth,
                        bgColor: "bg-blue-50",
                        textColor: "text-blue-700",
                    },
                    {
                        title: "Avg. Profit Margin",
                        industryValue: industryBenchmarks.avgProfitMargin,
                        yourValue: yourMetrics.avgProfitMargin,
                        bgColor: "bg-green-50",
                        textColor: "text-green-700",
                    },
                    {
                        title: "Customer Retention",
                        industryValue: industryBenchmarks.avgCustomerRetention,
                        yourValue: yourMetrics.avgCustomerRetention,
                        bgColor: "bg-purple-50",
                        textColor: "text-purple-700",
                    },
                    {
                        title: "Market Share",
                        industryValue: industryBenchmarks.marketShare,
                        yourValue: yourMetrics.marketShare,
                        bgColor: "bg-orange-50",
                        textColor: "text-orange-700",
                    },
                ].map((metric, index) => (
                    <div key={index} className={`p-4 rounded-lg ${metric.bgColor}`}>
                        <h4 className="text-sm font-medium text-gray-600">{metric.title}</h4>
                        <p className={`text-2xl font-semibold ${metric.textColor}`}>
                            {metric.industryValue}
                        </p>
                        <p className={`text-sm ${metric.textColor} mt-1`}>
                            Your {metric.title.split(" ")[1]}: {metric.yourValue}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BenchmarkMetricsKPIs;
